import { useCallback, useEffect, useLayoutEffect, useState } from 'react';

const COOLDOWN_MS = 60_000;

function secondsUntil(unlockAt) {
  return Math.max(0, Math.ceil((unlockAt - Date.now()) / 1000));
}

/**
 * 60s cooldown before the first resend and after each successful resend while the 2FA step is active.
 */
export function useTwoFactorResendCooldown(isActive) {
  const [unlockAt, setUnlockAt] = useState(null);
  const [secondsLeft, setSecondsLeft] = useState(0);

  useLayoutEffect(() => {
    if (isActive) {
      const until = Date.now() + COOLDOWN_MS;
      setUnlockAt(until);
      setSecondsLeft(secondsUntil(until));
    } else {
      setUnlockAt(null);
      setSecondsLeft(0);
    }
  }, [isActive]);

  useEffect(() => {
    if (unlockAt == null) {
      return undefined;
    }

    const tick = () => {
      setSecondsLeft(secondsUntil(unlockAt));
    };

    const id = setInterval(tick, 500);
    tick();
    return () => clearInterval(id);
  }, [unlockAt]);

  const restartCooldown = useCallback(() => {
    const until = Date.now() + COOLDOWN_MS;
    setUnlockAt(until);
    setSecondsLeft(secondsUntil(until));
  }, []);

  const canResend = Boolean(isActive && secondsLeft === 0);

  return { canResend, secondsLeft, restartCooldown };
}
